import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=5816f18e&scoped=true&"
import script from "./AppAvatar.vue?vue&type=script&lang=js&"
export * from "./AppAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AppAvatar.vue?vue&type=style&index=0&id=5816f18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816f18e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5816f18e')) {
      api.createRecord('5816f18e', component.options)
    } else {
      api.reload('5816f18e', component.options)
    }
    module.hot.accept("./AppAvatar.vue?vue&type=template&id=5816f18e&scoped=true&", function () {
      api.rerender('5816f18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/components/AppAvatar.vue"
export default component.exports